import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()
  const safeOffset = {
    top: "calc(1rem + var(--safe-area-top))",
    right: "calc(1rem + var(--safe-area-right))",
    bottom: "calc(1rem + var(--safe-area-bottom))",
    left: "calc(1rem + var(--safe-area-left))",
  }

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      offset={safeOffset}
      mobileOffset={safeOffset}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
